(function () {
(function($) {
    const behavior = "polyu_theme.header-configuration";
    Drupal.behaviors[behavior] = {
        attach: (context, settings)=>{}
    };
    $(function() {
        polyu_handle_header_scrolling();
        handle_header_share_links();
        polyu_setHeaderMargin();
        polyu_handle_menu();
    });
    function polyu_setHeaderMargin() {
        const brandingHeight = $(".region--branding").outerHeight();
        $(".region--header").css("margin-top", brandingHeight + "px");
    }
    $(window).on("resize", polyu_setHeaderMargin);
    function polyu_handle_header_scrolling() {
        let last_scroll_top = 0;
        let topThreshold = 100;
        $(window).bind("scroll", function() {
            let affectedDivs = $(".region--branding, .header-container, .header-container .header-wrapper, .header-container .logos-section, .header-container .polyu-main-logo, .header-container .poly-study-logo, .header-container .menus-sections, .header-container .site-switcher, .header-container .header-links");
            let scroll_top = $(window).scrollTop();
            if (scroll_top > topThreshold) {
                affectedDivs.addClass("scrolling");
                $(".navigation-container--desktop").addClass("scrolling");
            } else affectedDivs.removeClass("scrolling");
            if (scroll_top > last_scroll_top) {
                if (scroll_top > topThreshold) affectedDivs.addClass("scrolling");
            } else affectedDivs.removeClass("scrolling");
            if (scroll_top < topThreshold) $(".navigation-container--desktop").removeClass("scrolling");
            last_scroll_top = scroll_top;
        });
    }
    function handle_header_share_links() {
        $(".toggle-share-menu").on("click", function(e) {
            e.preventDefault();
            $(".header-share .share-options").toggleClass("is-active");
        });
        const sharers = {
            facebook: [
                {
                    sharer_link: "https://www.facebook.com/sharer/sharer.php?u="
                },
                {
                    target: "facebook-share-dialog"
                },
                {
                    trigger: ".trigger-facebook-share"
                }
            ],
            linkedin: [
                {
                    sharer_link: "https://www.linkedin.com/shareArticle?mini=true&url="
                },
                {
                    target: "linkedin-share-dialog"
                },
                {
                    trigger: ".trigger-linkedin-share"
                }
            ],
            twitter: [
                {
                    sharer_link: "https://twitter.com/share?url="
                },
                {
                    target: "twitter-share-dialog"
                },
                {
                    trigger: ".trigger-twitter-share"
                }
            ],
            weibo: [
                {
                    sharer_link: "http://service.weibo.com/share/share.php?url="
                },
                {
                    target: "weibo-share-dialog"
                },
                {
                    trigger: ".trigger-weibo-share"
                }
            ]
        };
        for(const key in sharers)$(sharers[key][2].trigger).on("click", function(e) {
            e.preventDefault();
            let currentLink = encodeURIComponent(window.location.href);
            window.open(sharers[key][0].sharer_link + currentLink, sharers[key][1].target, "width=626,height=436");
        });
        $(".trigger-copy-link").on("click", function(e) {
            e.preventDefault();
            let currentLink = window.location.href;
            let tempInput = document.createElement("input");
            tempInput.value = currentLink;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand("copy");
            document.body.removeChild(tempInput);
            $(this).html('<i class="fa-solid fa-copy"></i>Link Copied');
        });
        $(".trigger-mail-share").on("click", function(e) {
            e.preventDefault();
            let currentLink = encodeURIComponent(window.location.href);
            let mailSubject = encodeURIComponent("Check out this link");
            window.location.href = "mailto:?subject=" + mailSubject + "&body=" + currentLink;
        });
    }
    function polyu_handle_menu() {
        const menu_open_btn = $(".bars-icon");
        const menu_close_btn = $(".close-btn");
        const menu_section = $(".navigation-container--mobile");
        const menu_item = $(".menu__item");
        menu_open_btn.on("click", function() {
            menu_section.addClass("active");
        });
        menu_close_btn.on("click", function() {
            menu_section.removeClass("active");
        });
        menu_item.on("click", function() {
            if ($(this).children(".menu").hasClass("active")) $(this).children(".menu").removeClass("active");
            else $(this).children(".menu").addClass("active");
            $(this).siblings().children(".menu").removeClass("active");
        });
    }
})(jQuery);

})();
//# sourceMappingURL=block--config-pages--header-configuration.js.map
